/**
 * Text utils — extraídos de ForecastPage.tsx (P7 split).
 *
 * Helpers puros para normalización + extracción de texto de campos
 * multiidioma (UnifiedProduct.unifiedName puede ser string o
 * { en_US, es_MX }).
 */

export function normalizeText(text: string): string {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function getSearchableText(
  text: string | { en_US: string; es_MX: string } | null,
): string {
  if (!text) return "";
  if (typeof text === "string") return text;
  const es = text.es_MX || "";
  const en = text.en_US || "";
  return `${es} ${en}`.trim();
}

export function getDisplayText(
  text: string | { en_US: string; es_MX: string } | null,
): string {
  if (!text) return "";
  if (typeof text === "string") return text;
  return text.es_MX || text.en_US || "";
}
